<script setup>
import { computed, ref, watch } from "vue";
const props = defineProps({ modelValue: Boolean, fileName: { type: String, default: "" }, saving: Boolean });
const emit = defineEmits(["update:modelValue", "confirm"]);
const signature = ref("");
const visible = computed({ get: () => props.modelValue, set: value => { if (!props.saving) emit("update:modelValue", value); } });
watch(() => props.modelValue, value => { if (value) signature.value = ""; });
// Firmas que contiene el fichero (backend `signatures`): el solicitante,
// Grupo Andrés o ambos — cualquiera de las partes puede firmar primero.
const SIGNATURES = ["applicant", "director", "both"];
const confirm = () => {
  if (props.saving || !SIGNATURES.includes(signature.value)) return;
  emit("confirm", { signatures: signature.value });
};
</script>

<template>
  <el-dialog v-model="visible" title="Subir convenio" width="560px" class="social-fund-agreement-upload-dialog"
    :close-on-click-modal="!saving" :close-on-press-escape="!saving" :show-close="!saving">
    <form @submit.prevent="confirm">
      <p class="social-fund-agreement-upload-dialog__file"><b>Archivo:</b> {{ fileName }}</p>
      <p id="agreement-signature-label">Indica las firmas que contiene este documento:</p>
      <el-radio-group v-model="signature" aria-labelledby="agreement-signature-label" :disabled="saving">
        <el-radio label="applicant">Solo por el solicitante (falta la firma de Grupo Andrés)</el-radio>
        <el-radio label="director">Solo por Grupo Andrés (el solicitante tendrá que firmarlo y subirlo)</el-radio>
        <el-radio label="both">Por ambas partes (A51 tendrá que validarlo)</el-radio>
      </el-radio-group>
      <p class="social-fund-agreement-upload-dialog__hint">Para aprobar para pago, el convenio debe estar firmado por ambas partes y validado por A51.</p>
      <footer>
        <button type="button" class="btn btn_yellow" :disabled="saving" @click="visible = false">CANCELAR</button>
        <button type="submit" class="btn btn_red" :disabled="saving || !signature">{{ saving ? "SUBIENDO…" : "SUBIR CONVENIO" }}</button>
      </footer>
    </form>
  </el-dialog>
</template>

<style scoped lang="scss">
:global(.el-dialog.social-fund-agreement-upload-dialog) { border-radius: 20px; max-width: calc(100vw - 24px); }
.social-fund-agreement-upload-dialog__file { overflow-wrap: anywhere; }
.social-fund-agreement-upload-dialog__hint { margin-top: 20px; color: #626987; }
:deep(.el-radio-group) { display: flex; flex-direction: column; align-items: stretch; gap: 16px; }
:deep(.el-radio) { height: auto; min-height: 44px; margin: 0; white-space: normal; }
:deep(.el-radio__label) { white-space: normal; line-height: 1.5; }
footer { display: flex; justify-content: flex-end; gap: 12px; margin-top: 24px; }
@media (max-width: 767px) { footer { flex-direction: column; } footer button { width: 100%; } }
</style>
